export default __webpack_public_path__ + "static/media/BrutalType-Bold.5f16d35d.woff";